<template>
  <div>
    <button class="tla-btn tla-btn--info tla-btn--spaced-bottom" type="button" @click="openOverlay()" v-html="buttonText"></button>
    <div class="call-me-now-overlay" v-bind:class="{ 'call-me-now-overlay--open': modalOpen }">
      <div class="call-me-now-overlay__window">
        <div v-if="loadingPage">
          <loader-component class="loader call-me-now-overlay__loader"/>
          <span class="call-me-now-overlay__text" v-html="loadingMessage">
          </span>
        </div>
        <div v-else class="call-me-now-overlay-content">
          <div class="overlay-close-group" @click="toggleModal()">
            <span class="overlay-close-group__text">Close</span>
            <img src="@/assets/images/icon/cta-close.svg"/>
          </div>
          <img class="call-me-now-overlay-content__logo" src="@/assets/images/aap-logo-colour.svg"/>
          <span class="call-me-now-overlay-content__text" v-html="overlayText"></span>
          <img class="call-me-now-overlay-content__image" src="@/assets/images/call-me-now-overlay-image.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import LoaderComponent from '../ui/LoaderComponent.vue';
import ExtraData from '../../models/ExtraData';

const PostEnquiryModule = namespace('postEnquiryModule');

@Component({
  components: {
  'loader-component': LoaderComponent
  }
  })
export default class CallMeNowComponent extends Vue {
  @PostEnquiryModule.Action public submitEnquiryExtraData;

  @Prop({ default: 'Call Me Now' })
  public buttonText!: string;

  @Prop({ default: 'Sorry, all our assistants are busy at the moment but we’ll call you as soon as possible to progress your enquiry.' })
  public overlayText!: string;

  public modalOpen: boolean = false;

  public loadingPage: boolean = true;

  public loadingMessage: string = 'Bear with us...';

  public toggleModal(): void {
    if (this.modalOpen) {
      this.modalOpen = !this.modalOpen;
    } else {
      this.modalOpen = !this.modalOpen;
    }
  }

  public openOverlay(): void {
    this.toggleModal();
    this.submitCallMeNowExtraData();
    setTimeout(() => {
      this.loadingPage = false;
    }, 1000);
  }

  public submitCallMeNowExtraData() {
    const data: ExtraData[] = [
      {
        keyName: 'CallMeNowInterest',
        keyValue: 'Yes'
      }
    ];
    this.submitEnquiryExtraData(data);
  }
}
</script>
